module.exports = __webpack_public_path__ + "static/top-illustration-6ce7e2fad885354ba0a30a35983249d3.jpg";